import React, { useContext } from 'react';
import MixtureForm from './MixtureForm';

const UpdateMixtureForm = ({ rowIndex, mixture, table, onCloseModal }) => {
    // Obtenir la référence au modal parent pour pouvoir le fermer
    const closeModal = () => {
        // Rechercher le parent modal le plus proche et le fermer
        console.log('close')
        if (onCloseModal) {
            onCloseModal();
        } else {
            const modal = document.querySelector('[role="dialog"]');
            if (modal && typeof modal.close === 'function') {
                modal.close();
            }
        }

    };

    console.log(table)

    return (
        <MixtureForm
            mode="update"
            onClose={closeModal}
            mixture={mixture}
            rowIndex={rowIndex}
            table={table}
        />
    );
};

export default UpdateMixtureForm;
